import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { ContentHighlightBlock } from 'src/app/model/content-highlight-block';
import { BundleType, SettingsCourseDetailsScreenOptions, SwiperComponent } from 'library-explorer';
import { HighlightBlockContentType } from 'src/app/model/enums/highlight-block-content-type.enum';
import { SettingsService } from '@app/services/settings.service';
import { PayableNodeNavigationService } from 'src/app/services/payable-node-navigation.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-content-highlight-block',
    templateUrl: './content-highlight-block.component.html',
    styleUrls: ['./content-highlight-block.component.scss'],
    standalone: false
})
export class ContentHighlightBlockComponent implements OnInit {

  @Input() public set block(value: ContentHighlightBlock) {
    if (value) {
      this._block = value;

      this.getContentHighlights(value);
    }
  }

  public get block() {
    return this._block;
  }

  public items: any[] = [];

  public isPaymentEnabled = false;
  public courseDetailsEnabled = false;
  private _block: ContentHighlightBlock;

  constructor(
    private readonly settingsService: SettingsService,
    private readonly paymentService: PaymentService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly payableNodeNavigationService: PayableNodeNavigationService
  ) { }

  ngOnInit() {
    combineLatest([
      this.settingsService.getSettings(),
      this.authService.isAuthorized()
    ]).subscribe(([settings, isLoggedIn]) => {
      const { courseDetailsScreen} = settings.course;
      this.courseDetailsEnabled = courseDetailsScreen === SettingsCourseDetailsScreenOptions.ENABLED_FOR_ALL_USERS
        || (courseDetailsScreen === SettingsCourseDetailsScreenOptions.ENABLED_FOR_LOGGED_IN_USERS && isLoggedIn);
    });

    this.paymentService.getPaymentConfig().subscribe(res => {
      this.isPaymentEnabled = !!res.enabled;
    });
  }

  public navigate({ event, item }): void {
    switch (item.bundle) {
      case BundleType.CLASS:
        this.router.navigate(['/courses'], { queryParams: { classID: item.id }, state: { autoOpen: true }});
        break;
      case BundleType.COURSE:
        const data = {
          ...item,
          bundle: BundleType.COURSE,
          uuid: item.id
        };
        this.payableNodeNavigationService.navigate(data, event);

        break;
      case BundleType.MODULE:
        this.router.navigate(['/lessons'], { 
          queryParams: { moduleID: item.id, courseID: item.parentCourseId }, 
          state: { autoOpen: true }});
        break;
      case BundleType.LESSON:
      case BundleType.QUIZ:
        this.router.navigate(['/chapters'], { 
          queryParams: { lessonID: item.id, courseID: item.parentCourseId }, 
          state: { autoOpen: true }});
        break;
    }
  }

  public openDetails(item: any): void {
    this.payableNodeNavigationService.openCourseDetails(item, true).subscribe();
  }

  private getContentHighlights(value: ContentHighlightBlock): void {
    switch (value.gettingContentType) {
      case HighlightBlockContentType.AUTOMATIC:
      case HighlightBlockContentType.MANUAL:
      case HighlightBlockContentType.AUTOMATIC_IN_PROGRESS:
        this.items = value.automaticContentItems || [];
        break;
      case HighlightBlockContentType.MANUAL_SELECTION:
        this.items = value.contents || [];
        break;
    }
  }
}
